import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

const parseNumeric = (value) => (typeof value === 'string' ? parseFloat(value) : value);

export const ArrowLine = ({ color, sx, width, height }) => (
  <Box
    as="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${parseNumeric(width)} ${parseNumeric(height)}`}
    fill="none"
    sx={{
      '& path': {
        fill: color,
      },
      ...sx,
    }}
  >
    <path d="M32.3536 4.35355C32.5488 4.15829 32.5488 3.84171 32.3536 3.64645L29.1716 0.464466C28.9763 0.269204 28.6597 0.269204 28.4645 0.464466C28.2692 0.659728 28.2692 0.976311 28.4645 1.17157L31.2929 4L28.4645 6.82843C28.2692 7.02369 28.2692 7.34027 28.4645 7.53553C28.6597 7.7308 28.9763 7.7308 29.1716 7.53553L32.3536 4.35355ZM0 4V4.5H32V4V3.5H0V4Z" />
  </Box>
);

ArrowLine.propTypes = {
  color: PropTypes.string,
  sx: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ArrowLine.defaultProps = {
  color: '#6D33FF',
  width: '33px',
  height: '8px',
  sx: {},
};

export default ArrowLine;
